// Görev 7 — sol menüdeki tek "Onaylarım" yaprağının rozeti için saf kurallar
// (spec 2026-08-05-onaylar-paneli). Axios İMPORT ETMEZ: hook dosyasından ayrı
// durur ki testi CRA5'in axios ESM sorununa hiç girmesin (performanceInboxBadge.js
// de aynı sebeple ayrılmıştı).

import { APPROVAL_CATEGORIES } from '../pages/approvals/config/categories';

export const APPROVALS_PATH = '/approvals';

// 99'dan sonrası "99+" — rozet menü öğesini taşırmasın.
export const MAX_BADGE = 99;

// Panel her çekişinde kesin toplamı bu olayla yayınlar; 60 sn önbellekli
// sayaçtan beslenen rozet onu ANINDA benimser (iş bitince TTL beklenmez).
// pages/approvals/ApprovalsHubPage.js bu SABİTİ İTHAL EDER, kendi literal'ini
// taşımaz — dispatch ettiği CustomEvent adı ile burada dinlenen ad TEK
// kaynaktan geldiği için sapma yapısal olarak imkânsızdır (rename otomatik
// her iki tarafı da değiştirir, ayrı bir pin testine gerek yoktur; eski
// kaynak-tarayan pin testi bu yüzden commit 5dfa13b8'de kaldırıldı).
export const APPROVALS_COUNT_EVENT = 'approvals:count';

// Rozet her rota değişiminde değil, sayıyı DEĞİŞTİREBİLECEK bir sayfadan
// çıkarken tazelenir: dokuz onay listesinin her birindeki onay/red işlemi
// bekleyen sayısını düşürür.
export const APPROVAL_ROUTE_PREFIXES = [
  ...APPROVAL_CATEGORIES.map((c) => c.path.split('?')[0]),
  APPROVALS_PATH,
];

export function shouldRefreshApprovalsBadge(prevPath, nextPath) {
  if (!prevPath || prevPath === nextPath) return false;
  return APPROVAL_ROUTE_PREFIXES.some((prefix) => prevPath.startsWith(prefix));
}

export function formatBadgeCount(count) {
  if (!count || count < 1) return null;
  return count > MAX_BADGE ? `${MAX_BADGE}+` : String(count);
}
